import { WallpaperConfig } from '../config/wallpaper-config';

export function wallpaperFormat(src) {
  return /\.html$/.test(src)
    ? WallpaperConfig.format.HTML5
    : WallpaperConfig.format.IMAGE;
}
